export default __webpack_public_path__ + "static/Casa_Batllo_Barcelona_Spain-6b6f4e9aa124ab8bf06c35f7a76346f6.jpg";